import UniversalLoader from "oc-threejs/loader/UniversalLoader";

class MaterialFactory {
    constructor(texture_root, delegateMaterialFactory = null) {
        this.texture_root = texture_root;
        this.delegateMaterialFactory = delegateMaterialFactory;
        this.materials = {};
    }

    create(materialName) {
        if (!this.materials[materialName]) {
            this.materials[materialName] = this.createMaterial_(materialName);
        }
        if (!this.materials[materialName] && this.delegateMaterialFactory) {
            this.materials[materialName] = this.delegateMaterialFactory.create(materialName);
        }
        if(!this.materials[materialName]) {
            const material = APP.sceneImporter._createMaterialPbr(materialName);
            if(material) material.envMap = null;
            this.materials[materialName] = material;
        }
        if (!this.materials[materialName]) {
            this.materials[materialName] = new THREE.MeshBasicMaterial({ color: 0xffffff });
            console.warn("Missing Material ", materialName);
        }

        return this.materials[materialName];
    }

    createMaterial_(materialName) {
        throw "not yet implemented";
    }
}

export default class MaterialLib extends MaterialFactory {
    constructor(texture_root, delegateMaterialFactory = null) {
        super(texture_root, delegateMaterialFactory);

        this.textureCube = UniversalLoader.loadTextureCube([
            this.texture_root + "pos-x.png",
            this.texture_root + "neg-x.png",
            this.texture_root + "pos-y.png",
            this.texture_root + "neg-y.png",
            this.texture_root + "pos-z.png",
            this.texture_root + "neg-z.png",
        ]);
    }

    createMaterial_(materialName) {
        const textureCube = this.textureCube;
        let material = null;
        let texture = null;
        let texture_map_rubber = null;
        const loadTexture = (name) => UniversalLoader.loadTexture(this.texture_root + name);

        switch (materialName) {
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // / from here Code Copy from Hrn. Kohli
            // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            case "CHROM":
                /* material = new THREE.MeshStandardMaterial({
                    color: 0xFFFFFF,
                    //specular:	0xFFFFFF,
                    envMap: textureCube,
                    combine: THREE.MixOperation,
                    reflectivity: 0.4
                });
                break; */
                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    //specular:	0xFFFFFF,
                    // envMap: textureCube,
                    /* combine: THREE.MixOperation, */
                    roughness: 0.5,
                    metalness: 0.2,
                });
                break;

            case "CHROM_MATT":
                material = new THREE.MeshStandardMaterial({
                    color: 0xc8c8c8,
                    roughness: 0.4,
                    metalness: 1,
                    // envMapIntensity: 0.3,
                    // envMap: textureCube, // important -- especially for metals!
                });
                break;

            case "CHROM_Bogengriff":
                material = new THREE.MeshStandardMaterial({
                    color: 0xe0e0e0,
                    roughness: 0.3,
                    metalness: 0.3,
                    // envMapIntensity: 0.3,
                    // envMap: textureCube, // important -- especially for metals!
                });
                break;

            case "CHROM_Sockelgriff":
                material = new THREE.MeshStandardMaterial({
                    color: 0xe0e0e0,
                    roughness: 0.3,
                    metalness: 0.3,
                    // envMapIntensity: 0.3,
                    // envMap: textureCube, // important -- especially for metals!
                });
                break;

            case "CHROM_Buegelgriff":
                material = new THREE.MeshStandardMaterial({
                    color: 0xe0e0e0,
                    roughness: 0.3,
                    metalness: 0.3,
                    // envMapIntensity: 0.3,
                    // envMap: textureCube, // important -- especially for metals!
                });
                break;

            case "CHROM_Moebelknopf":
                material = new THREE.MeshStandardMaterial({
                    color: 0xe0e0e0,
                    roughness: 0.3,
                    metalness: 0.3,
                    // envMapIntensity: 0.3,
                    // envMap: textureCube, // important -- especially for metals!
                });
                break;

            case "CHROM_Griffe_Bake_matt":
                texture = loadTexture("bake_griffe_champagner.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                //material = new THREE.MeshStandardMaterial( {
                //    map:        texture,
                //    envMap:     textureCube,
                //    bumpScale: 0,
                //    color: 0xFFFFFF,
                //    metalness: 0.7,
                //    roughness: 0.1,
                //    shading: THREE.SmoothShading
                //} );

                material = new THREE.MeshStandardMaterial({
                    color: 0xeeeeee,
                    specular: 0xffffff,
                    map: texture,
                    // envMap: textureCube,
                    combine: THREE.MixOperation,
                    blending: THREE.AdditiveBlending,
                    reflectivity: 0.1,
                });
                break;

            case "CHROM_Griffe_Bake":
                texture = loadTexture("bake_griffe_champagner.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                //material = new THREE.MeshStandardMaterial( {
                //    map:        texture,
                //    envMap:     textureCube,
                //    bumpScale: 0,
                //    color: 0xFFFFFF,
                //    metalness: 0.7,
                //    roughness: 0.1,
                //    shading: THREE.SmoothShading
                //} );

                material = new THREE.MeshStandardMaterial({
                    color: 0xeeeeee,
                    specular: 0xffffff,
                    map: texture,
                    // envMap: textureCube,
                    combine: THREE.MixOperation,
                    blending: THREE.AdditiveBlending,
                    reflectivity: 0.2,
                });
                break;

            case "CLOTH":
                texture = loadTexture("hemd.png");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    map: texture,
                    combine: THREE.MixOperation,
                    reflectivity: 0.0,
                });
                break;

            case "CLOTH_HOSE":
                texture = loadTexture("Hose.png");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    //diffuse:     0x000000,
                    map: texture,
                    combine: THREE.MixOperation,
                    reflectivity: 0.0,
                });
                break;

            case "ALU_MATT":
                material = new THREE.MeshStandardMaterial({
                    color: 0xdddddd,
                    //specular:	0x0000FF,
                    //diffuse: 	0x999999,
                    // envMap: textureCube,
                    //combine: 	THREE.MixOperation,
                    reflectivity: 0.03,
                });
                break;

            case "KUNSTSTOFF_GRAU":
                material = new THREE.MeshStandardMaterial({
                    color: 0xc5c5c3,
                    specular: 0xffffff,
                    //envMap: 	textureCube,
                    //combine: 	THREE.MixOperation,
                    //reflectivity: 0.5
                });
                break;

            case "PLASTIC_BLACK":
                material = new THREE.MeshStandardMaterial({
                    color: 0x222222,
                    specular: 0x555555,
                    side: THREE.DoubleSide,
                    //envMap: 	textureCube,
                    //combine: 	THREE.MixOperation,
                    //reflectivity: 0.5
                });
                break;

            case "KUNSTSTOFF_GRAU_HELL":
                texture = loadTexture("GREY_Tile.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(3, 3);

                material = new THREE.MeshStandardMaterial({
                    color: 0xeeeeee,
                    specular: 0x202020,
                    map: texture,
                    //bumpmap: 	bump_map_rubber,
                    blending: THREE.AdditiveBlending,
                    //depthTest: false,
                    //depthWrite: false,
                    //bumpScale: 	0.00001,
                    side: THREE.FrontSide,
                    //combine: 	THREE.MixOperation,
                });
                break;

            case "KRAWATTE":
                texture = loadTexture("Trevira_3d.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(5, 5);

                material = new THREE.MeshStandardMaterial({
                    color: 0xeeeeee,
                    specular: 0x202020,
                    map: texture,
                    //bumpmap: 	bump_map_rubber,
                    blending: THREE.AdditiveBlending,
                    //depthTest: false,
                    //depthWrite: false,
                    //bumpScale: 	0.00001,
                    side: THREE.FrontSide,
                    //combine: 	THREE.MixOperation,
                });
                break;

            case "bake_single_lift":
                texture = loadTexture("bake_single_lift.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    map: texture,
                });

                break;

            case "bake_lift_700":
                texture = loadTexture("bake_ambos_lift_700.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    map: texture,
                });
                break;

            case "bake_lift_700_2":
                texture = loadTexture("bake_ambos_lift_700_2.jpg");
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                texture.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    map: texture,
                });
                break;

            case "HEMD_NEW":
                texture_map_rubber = loadTexture("hemd_new_1024.png");
                texture_map_rubber.wrapS = texture_map_rubber.wrapT = THREE.RepeatWrapping;
                texture_map_rubber.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    ambient: 0x000000,
                    map: texture_map_rubber,
                    side: THREE.DoubleSide,
                });
                break;

            case "HOSE_NEW":
                texture_map_rubber = loadTexture("hose_new_1024.png");
                texture_map_rubber.wrapS = texture_map_rubber.wrapT = THREE.RepeatWrapping;
                texture_map_rubber.repeat.set(1, 1);

                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    ambient: 0x000000,
                    map: texture_map_rubber,
                    side: THREE.DoubleSide,
                });
                break;

            case "Kupfer":
                material = new THREE.MeshStandardMaterial({
                    color: 0x96531d,
                    specular: 0xffffff,
                    //envMap:     textureCube_griffe,
                    // envMap: textureCube,
                    reflectivity: 0.2,
                });
                break;

            case "black_used_look":
                texture_map_rubber = loadTexture("diff_black.jpg");
                texture_map_rubber.wrapS = texture_map_rubber.wrapT = THREE.RepeatWrapping;
                texture_map_rubber.repeat.set(5, 5);

                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    specular: 0xffffff,
                    map: texture_map_rubber,
                    //envMap:     textureCube_griffe,
                    // envMap: textureCube,
                    reflectivity: 0.03,
                });
                break;

            case "glas":
                var options = {
                    color: new THREE.Color(0xdddddd),
                    transparent: true,
                    opacity: 0.3,
                    shininess: 10000,
                };
                const raum = APP.arrangement.raum.object3d;
                if (raum.envmap) {
                    options.envMap = raum.envmap;
                    options.combine = THREE.MixOperation;
                    options.reflectivity = 0.1;
                }
                material = new THREE.MeshStandardMaterial(options);
                break;

            case "spiegel":
                material = new THREE.MeshBasicMaterial({ color: 0xdddddd });
                break;

            case "WAESCHESACK":
                material = new THREE.MeshStandardMaterial({
                    color: 0xffffff,
                    roughness: 1,
                    metalness: 0,
                    // envMapIntensity: 1,
                    // envMap: textureCube, // important -- especially for metals!
                });
                break;

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // / until here
            // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        }

        return material;
    }
}
